import React from "react";

export const SkillsHead = () => {
  return (
    <>
      <div className="mx-auto flex max-w-[58rem] flex-col space-y-3 sm:text-center sm:flex sm:py-10 xs:px-4 xs:py-5">
        <span className="font-bold text-3xl sm:text-3xl md:text-6xl text-white">
          Technologies
        </span>

        
        <p className="max-w-[95%] leading-normal text-muted-foreground sm:text-lg sm:leading-7 text-gray-300">
          Digital Solutions that Blend Innovation, Functionality, and Performance to Deliver Exceptional User Experiences.
        </p>

      </div>
    </>
  );
};
